import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Paper
} from '@mui/material';
import HtmlIcon from '@mui/icons-material/Html';

const HtmlViewerPage: React.FC = () => {
  const [htmlInput, setHtmlInput] = React.useState('');

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: { xs: 1, sm: 2, md: 3 } }}>
      <Card elevation={3}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <HtmlIcon sx={{ mr: 1.5, fontSize: { xs: 28, sm: 32 }, color: 'primary.main' }} />
            <Typography variant="h4" component="h1">
              HTML Viewer
            </Typography>
          </Box>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Paste your HTML code into the text area below to see it rendered.
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={10}
            value={htmlInput}
            onChange={(e) => setHtmlInput(e.target.value)}
            placeholder="Paste your HTML code here..."
            variant="outlined"
            sx={{
              mb: 3,
              '& .MuiInputBase-input': {
                fontFamily: 'monospace',
                fontSize: '14px'
              }
            }}
          />

          <Typography variant="h6" gutterBottom sx={{mt: 2}}>
            Rendered HTML:
          </Typography>
          <Paper elevation={1} sx={{ p: 2, minHeight: 300, overflow: 'auto' }}>
            {htmlInput ? (
              <div dangerouslySetInnerHTML={{ __html: htmlInput }} />
            ) : (
              <Typography color="text.secondary">Preview will appear here.</Typography>
            )}
          </Paper>

        </CardContent>
      </Card>
    </Box>
  );
};

export default HtmlViewerPage;
